'use client';
import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import { VIEW_MODE } from '@/components/app/archive/helpers/hooks/type';

import { useViewModeStore } from '@/store/view-mode.store';

import { DATA_CY_VIEW_MODE_GRID, DATA_CY_VIEW_MODE_LIST } from '@/constant/cypress';
import imagesList from '@/constant/images-list';

export default function ViewMode() {
  const { viewMode, setViewMode } = useViewModeStore();
  return (
    <Container center className='absolute left-0 hidden h-full p-[5px] md:flex'>
      <Container className='flex h-[53px] w-[103px] items-center justify-center rounded-lg bg-[#F9FAFC]'>
        <Container
          data-cy={DATA_CY_VIEW_MODE_GRID}
          className={cn(
            'h-11 w-11 cursor-pointer rounded-lg',
            viewMode === VIEW_MODE.GRID && 'border-[1px] border-[#E5E8EB] bg-[#FFFFFF]',
          )}
          center
          onClick={() => setViewMode(VIEW_MODE.GRID)}
        >
          <imagesList.icons.gridViewIcon
            className={cn(viewMode === VIEW_MODE.GRID && '*:fill-[#FF9606]')}
          />
        </Container>
        <Container
          data-cy={DATA_CY_VIEW_MODE_LIST}
          className={cn(
            'h-11 w-11 cursor-pointer rounded-lg',
            viewMode === VIEW_MODE.LIST && 'border-[1px] border-[#E5E8EB] bg-[#FFFFFF]',
          )}
          center
          onClick={() => setViewMode(VIEW_MODE.LIST)}
        >
          <imagesList.icons.rowViewIcon
            className={cn(
              viewMode === VIEW_MODE.LIST ? '*:fill-[#FF9606]' : '*:fill-[#9B9DA2]',
            )}
          />
        </Container>
      </Container>
    </Container>
  );
}
